// extracted by mini-css-extract-plugin
module.exports = {"title":"QMBfx","separator":"FsCUH","paragraph":"_1a9Cs","button":"GWSI5","rightButton":"_36cyL GWSI5"};